<template>
  <div id="viewBrands">
    <div class="bread container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/brands'}">品牌列表</el-breadcrumb-item>
        <el-breadcrumb-item>品牌详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container" style="margin-bottom:30px">
      <img :src="serve  + banner " style="width:100%">
    </div>
    <div class="container">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <div class="l" style="text-align:center;background-color: #15B595;color:#fff;">品牌详情</div>
            <div class="box">
              <div class="name lv2Text">{{data.name}}</div>
              <div style="border-bottom:1px solid #ddd;margin:0 250px;position: relative;top:-30px"></div>
              <div class="lv3Text row">
                品牌国别：
                <span class="lv2Text">{{data.country}}</span>
              </div>
              <div class="lv3Text row">
                代表产品：
                <span class="lv2Text" style="color:#15B595">{{data.main_products}}</span>
              </div>
              <div class="lv3Text row">品牌介绍：</div>
              <div class="lv2Text" v-html="data.info"></div>
              <div class="lv3Text row">
                加入时间：
                <span class="lv2Text">{{dayjs.unix(data.create_date).format('YYYY-MM-DD')}}</span>
              </div>
            </div>
          </div>
          <div v-if="$store.state.isLogin" style="margin-top:20px" align="right">
            <el-button size="small" v-if="data.is_collect==0" @click="like">收藏</el-button>
            <el-button size="small" v-if="data.is_collect==1" @click="dislike">取消收藏</el-button>
          </div>
          <div v-else style="margin-top:20px"></div>
          <div>
            <span
              style="color:#e2211c;text-align:center;background-color:whitesmoke;display:block;margin:0 auto;position: relative;width:100px;z-index:10"
            >品牌专卖</span>
          </div>
          <div style="border-bottom:1px solid #e2211c;margin:0 320px;position: relative;top:-8px"></div>
          <div style="margin-top:35px;" class="products">
            <el-row>
              <el-col :span="6" v-for="(item,index) of products" :key="index">
                <div class="item">
                  <div>
                    <router-link :to="'/product/'+item.id">
                      <img
                        :src="serve +item.images"
                        style="width:100%;height:221px;"
                      >
                    </router-link>
                  </div>
                  <div style="text-align:center;padding: 10px 0 5px 0">
                    <router-link
                      :to="'/product/'+item.id"
                      style="height:18px;overflow:hidden;display:inline-block"
                      class="link1"
                    >
                      <span class="lv2Text" style="padding:0 10px">{{item.title}}</span>
                    </router-link>
                  </div>
                  <div
                    align="center"
                    style="padding:5px 0 10px 0;"
                    class="lv0Text"
                  >&yen;{{item.selling_price}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="l" style="background-color: #E2211C;color:#fff;text-align:center">热销榜</div>
          <div class="d1" align="center">
            <div v-for="(item,index) of hot" :key="index" class="i1">
              <img :src="serve + '/'+item.images" class="cover2">
              <router-link :to="'/product/'+item.id">
                <div style="margin:10px 0;" class="title">
                  {{_.truncate(item.title, {
                  'length': 15
                  })}}
                </div>
              </router-link>
              <div class="lv0Text" style="margin-bottom:10px">&yen;{{item.selling_price}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      data: {},
      hot: {},
      banner: "",
      products: null
    };
  },
  watch: {},
  created() {
    //
    this.initData();
    this.axios
      .get(this.serve + "/product_info_hot", {
        params: {
          id: this.$route.query.id
        }
      })
      .then(res => {
        this.hot = res.data.data;
      });
    this.axios
      .get(this.serve + "/brand_product", {
        params: {
          id: this.$route.query.id
        }
      })
      .then(res => {
        this.products = res.data.data;
      });
  },
  methods: {
    //
    dislike() {
      this.axios
        .get(this.serve + "/collect/cancel_collect_brand", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            brand_id: this.$route.query.id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.initData();
          }
        });
    },
    like() {
      this.axios
        .get(this.serve + "/collect/collect_brand", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            brand_id: this.$route.query.id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.initData();
          }
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/get_banner?type=brand")
        .then(res => {
          this.banner = res.data.data.image;
        });
      this.axios
        .get(this.serve + "/brand_detail", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
    }
  }
};
</script>
<style lang="scss">
#viewBrands {
  .products {
    .link1 span:hover {
      color: #e2211c;
    }
    .item {
      border: 1px solid #ddd;
      background-color: #fff;
    }
  }
  .cover2 {
    width: 241px;
    display: block;
  }
  .i1 {
    border: 1px solid #ddd;
    margin-bottom: 20px;
    .title:hover {
      text-decoration: underline;
    }
  }
  .i1:hover {
    border-color: #e2211c;
  }
  .d1 {
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ddd;
    border-top-width: 0;
  }
  .row {
    margin-bottom: 10px;
  }
  .name {
    background-color: #fff;
    font-size: 18px;
    text-align: center;
    padding: 10px 0;
    width: 150px;
    margin: 0 auto;
    position: relative;
    z-index: 10;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    border-top-width: 0;
    padding: 20px;
  }
  .l {
    background-color: #f5faf9;
    border: 1px solid #ddd;
    padding: 10px 20px;
  }
  padding: 0 0 30px 0;
  .lv2Text {
    margin-bottom: 10px;
  }
  .tx1 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .t {
    height: 200px;
    margin-bottom: 20px;
  }
  .tx11 {
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .table {
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    .item {
      background-color: #fff;
      margin-bottom: 20px;
    }
  }
  .info {
    .el-button {
      float: right;
      margin-right: 20px;
      width: 100px;
    }
  }
}
</style>